<mat-dialog-content>
    <h2>{{ "POPUP_SESSION_TIMEOUT_TITLE" | translate }}</h2>
    <table>
        <tbody>
            <tr>
                <td style="width:30%" >
                    <i class="fa-solid fa-triangle-exclamation" style="font-size: 60px; color:#b32318;"></i>
                </td>
                <td style="width:70%">{{ "POPUP_SESSION_TIMEOUT_BODY" | translate }}</td>
            </tr>
        </tbody>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 20px;">
    <button mat-button class="btn-cancel" (click)="closeModal()"> {{ 'COMMON_BTN_OK' | translate }} </button>
</mat-dialog-actions>